<template>
    <div class="course-card col-xl-3 col-lg-4 col-md-6 col-sm-6 align-items-stretch d-flex" @click="$router.push({ name: 'curso', params: { id: course.id } })">
		<!-- align-items-stretch d-flex -->
        <div class="course-item">
            <div class="course-thumb set-bg text-right position-relative">
				<img class="w-100" :src="course.thumbnail" :alt="course.title" />
                <div v-if="course.progress && course.progress.id == 3" class="cover"></div>
                <div v-if="course.progress && course.progress.id == 3" class="price shadow"><font-awesome-icon icon="check-circle"  /> Completado</div>
            </div>
            <div class="course-info">
                <div class="course-text">
                    <h5>{{ course.title }}</h5>
                    <p>{{ course.description_short }}</p>
                </div>
                <div class="course-author row m-0 text-center text-secondary">
                    <div class="col">
                        <font-awesome-icon class="mr-1" icon="signal"  /> {{ course.level.name }}
                    </div>
                    <div class="col">
                        <font-awesome-icon class="mr-1" icon="music"  /> {{ course.category.name }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'course-card',
    props: ['course']
}
</script>

<style lang="scss" scoped>
	@import "@/variables.scss";
	
    .course-item {
		display: flex;
		-webkit-box-flex: 1;
		flex: 1 0 auto;
		-webkit-box-orient: vertical;
		-webkit-box-direction: normal;
		flex-direction: column;
		width: 100%;
		cursor: pointer;
		box-shadow: 0 10px 16px 0 rgba(0,0,0,0.07),0 3px 5px 0 rgba(0,0,0,0.07);
		transform: scale(1);
		transition: all 0.15s linear;
		background: #edf4f6;
		&:hover {
			transform: scale(1.02);
		}
		.course-thumb {
			height: auto;
			min-height: 200px;
			.cover {
				height: 100%;
				background-image: linear-gradient($main-color, $main-color-brown);
				opacity: 0.5;
				filter: alpha(opacity=50);
				position: absolute;
				top: 0;
				width: 100%;
			}
			.price {
				position: absolute;
				top: 0;
				right: 0;
				background: #4caf50;
			}
		}
		.course-info {
			display: flex;
			-webkit-box-flex: 1;
			flex: 1 0 auto;
			-webkit-box-orient: vertical;
			-webkit-box-direction: normal;
			flex-direction: column;
			.course-text {
				padding: 20px;
				-webkit-box-flex: 1;
				flex-grow: 1;
				h5 {
					margin-bottom: 10px;
				}
				p {
					line-height: 1.6;
					font-size: 16px;
					margin: 0;
				}
			}
			.course-author {
				svg {
					color: $main-color;
				}
			}
		}
	}
</style>


